import { oneMembershipDomainFetchye } from '@americanexpress/consumer-travel-base';
import { getActiveLocaleSelector, getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import { isConditionalFeature } from '@americanexpress/conditional-features';
import { hasVacationRentalsRule } from '../constants/featureConstants';
import { MODULE_NAME } from '../constants/modules';
import { MEMBERSHIP_QUERY } from '../graphql/membership';

export const loadMembershipDomain = (state) => async (dispatch) => {
  const activeLocale = getActiveLocaleSelector(state);

  const isLoggedIn = getIsLoggedInSelector(state);
  const hasVacationRentals = isConditionalFeature(hasVacationRentalsRule, state);

  if (!isLoggedIn || !hasVacationRentals) return;

  const fetcherOpts = {
    locale: activeLocale,
    reporting: {
      moduleID: MODULE_NAME,
      component: 'loadMembershipDomain',
    },
  };

  await dispatch(oneMembershipDomainFetchye(
    MEMBERSHIP_QUERY,
    {},
    fetcherOpts
  ));
};
